module.exports = __webpack_public_path__ + "img/img_3.67f884b9.webp";